import { palette } from '@/services/colors/palette';

export function useColors() {
  return palette;
}
